module.exports = __webpack_public_path__ + "img/transfer6.22fc974a.jpeg";